<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :loading="loading"
      :totalData="totalMerchants"
      :refresh-table="getData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
    <template v-slot:top>
      <TableTop
        :selectedData="selectedData"
        :loading="loading"
        @clear-selected="clearSelected"
        @open-switch-modal="openSwitchModal"
        @get-data="getData"
      />
      </template>
      <template v-slot:body-prepend>
        <tr>
          <td class="pa-3 d-sm-table-cell d-print-table-cell fixed-row" style="width: 150px;" />
          <td class="pa-4 d-sm-table-cell d-print-table-cell fixed-row">
            <v-checkbox
              v-model="selectAllData"
              @click="selectAll(selectAllData)"
              dense
              hide-details
            />
          </td>
          <td
            v-for="field in searchFields"
            :key="field.model"
            class="pa-3 d-sm-table-cell d-print-table-cell fixed-row"
            :style="{ width: field.width + 'px' }"
          >
            <component
              :is="field.type === 'autocomplete' ? 'v-autocomplete' : 'v-text-field'"
              v-model="search[field.model]"
              :label="field.label"
              :items="field.items"
              :loading="field.loading"
              :search-input.sync="field.searchInput"
              :item-text="field.itemText"
              :item-value="field.itemValue"
              style="width: 200px;"
              dense
              hide-details="true"
              clearable
              prepend-inner-icon="mdi-magnify"
              @keydown.enter="searchFilter"
              @click:clear="handleClear(field.model)"
            />
          </td>
          <td class="pa-3 d-sm-table-cell d-print-table-cell fixed-row" style="width: 150px;">
            <v-autocomplete
            style="width: 150px;"
              clearable
              v-model="search.request_by"
              :items="itemsInputer"
              item-text="userID"
              item-value="id"
              label="Inputer"
              :loading="loadingInputer"
              :search-input.sync="searchActiveUser"
              @change="searchFilter"
              hide-selected
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-sm-table-cell d-print-table-cell fixed-row" style="width: 150px;">
            <v-autocomplete
            style="width: 150px;"
              clearable
              v-model="search.approver_1"
              :items="itemsApproverOne"
              item-text="userID"
              item-value="id"
              label="Approver 1"
              :loading="loadingApproverOne"
              :search-input.sync="searchApproverOne"
              @change="searchFilter"
              hide-selected
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-sm-table-cell d-print-table-cell fixed-row" >
            <v-autocomplete
              style="width: 150px;"
              clearable
              v-model="search.approver_2"
              :items="itemsApproverTwo"
              item-text="userID"
              item-value="id"
              label="Approver 2"
              :loading="loadingApproverTwo"
              :search-input.sync="searchApproverTwo"
              @change="searchFilter"
              hide-selected
              hide-details="true"
              dense
            />
          </td>
        </tr>
      </template>
      <template v-slot:custom="{ item }">
        <v-checkbox
          class="ma-0"
          dense
          hide-details="true"
          v-model="selectedData"
          :value="item.id"
        />
      </template>
      </TableView>
    <v-dialog v-model="dialogPIC" width="500" persistent>
      <v-card>
        <v-card-title class="mb-4"> Select User </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12">
                <v-autocomplete
                  clearable
                  v-model="selectedPIC"
                  :items="itemsInputer"
                  item-text="userID"
                  item-value="id"
                  label="Inputer"
                  :loading="loadingInputer"
                  :search-input.sync="searchPIC"
                  dense
                />
              </v-col>
              <v-col cols="12" sm="12">
                <v-autocomplete
                  clearable
                  v-model="selectedApproverOne"
                  :items="itemsApproverOne"
                  item-text="userID"
                  item-value="id"
                  label="Approver 1"
                  :loading="loadingApproverOne"
                  :search-input.sync="searchModalApproverOne"
                  dense
                />
              </v-col>
              <v-col cols="12" sm="12">
                <v-autocomplete
                  clearable
                  v-model="selectedApproverTwo"
                  :items="itemsApproverTwo"
                  item-text="userID"
                  item-value="id"
                  label="Approver 2"
                  :loading="loadingApproverTwo"
                  :search-input.sync="searchModalApproverTwo"
                  dense
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn class="my-2 rounded-pill px-4 elevation-0" dark color="cancel" @click="resetFields">
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            class="rounded-pill px-6 elevation-0 mb-2"
            color="primary"
            @click="toStep2"
            :disabled="loading"
            :loading="loading"
          >
            Next
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSwitch" width="500" persistent>
      <v-card>
        <v-card-title> Are you sure want to switch ? </v-card-title>
        <v-card-text> Caution: this action cannot be undone ! </v-card-text>

        <v-divider class="mt-10" />

        <v-card-actions >
          <v-btn class="my-2 rounded-pill px-4 elevation-0" dark color="cancel" @click="toStep1"> Back </v-btn>
          <v-spacer />
          <v-btn
            class="my-2 rounded-pill px-4 elevation-0"
            color="primary"
            @click="switchPIC"
            :disabled="loading"
            :loading="loading"
          >
            Switch
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showProgressBar" persistent max-width="500">
      <div style="width: 100%; height: 10px; background-color: #146b76"></div> 
      <v-card class="d-flex flex-column align-center pa-4">
        <v-card-title class="text-h6 text-center">{{ progressTitle }}</v-card-title>

        <v-card-text class="d-flex flex-column align-center pa-4">
          <v-progress-linear :value="percentage" :color="progressColor" height="15" class="mb-3 rounded-xl " style="width: 100%"/>
          <div class="text-center">
            <strong>{{ Math.ceil(percentage) }}%</strong>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>

import changePicMixin from '../../components/change-pic/changePicMixin';

export default {
  mixins: [changePicMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableTop: () => import("../../components/change-pic/TableTop.vue"),
  },

};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
